<template>
  <div class="container">
    <el-form
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      label-width="200px"
    >
      <el-form-item label="更新后台版本号：" label-width="200px" prop="version">
        <el-input v-model="formData.version" width="100px"></el-input
        ><span>（当前版本号：{{ currentVersion }}）</span>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          style="margin-left: 215px"
          >提交</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    var validateVersion = (rule, value, callback) => {
      console.log(value, rule);
      if (value === "") {
        callback(new Error("版本号不能为空"));
      } else {
        callback();
      }
    };
    return {
      formData: {
        version: "",
      },
      currentVersion: "",
      rules: {
        version: [{ validator: validateVersion, trigger: ["blur",'change'] }],
      },
    };
  },
  mounted() {
    this.getVersion();
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateVersion()
        } else{
          this.$message.error("请按规则输入配置信息！")
        }
      });
    },
    async getVersion() {
      var api = "/manager/devops/css/param/getVersion";
      const res = await this.util.postRequest({
        url: api,
        method: "GET",
      });
      if (res.resultCode == 10000) {
        this.currentVersion = res.data;
      } else {
        this.$message.error(res.desc);
      }
      console.log("csOptions.vue getVersion:", res);
    },

    async updateVersion() {
      var api = "/manager/devops/css/param/updateVersion";
      const res = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {
          versionNum: this.formData.version,
        },
      });
      if (res.resultCode == 10000) {
        this.formData.version=""
        this.getVersion();
        this.$message.success("修改配置成功！")
      } else {
        this.$message.error(res.desc);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
}
::v-deep .el-form {
  width: 600px;
  margin: 0 auto;
  .el-form-item {
    display: flex;
    align-items: center;
    // justify-content: center;
    .el-form-item__content {
      display: flex;
      margin-left: 0 !important;
    }
    .el-form-item__label {
      padding: 0;
    }
  }
}
::v-deep  .el-input {
  width: auto;
  margin: 0 10px 0 0;
  .el-input__inner {
    width: 100px;
    height: 34px;
  }
}
</style>
